import { render } from "./MarkExamSubjectModal.vue?vue&type=template&id=5850bf7c"
import script from "./MarkExamSubjectModal.vue?vue&type=script&lang=js"
export * from "./MarkExamSubjectModal.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MarkExamSubjectModal.vue?vue&type=style&index=0&id=5850bf7c&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__